export const STATUS_PENDING_CHAT = 0;
export const STATUS_ACTIVE_CHAT = 1;
export const STATUS_CLOSED_CHAT = 2;
export const STATUS_CHATBOX_CHAT = 3;
export const STATUS_OPERATORS_CHAT = 4;
export const STATUS_BOT_CHAT = 5;

export const CHAT_INITIATOR_DEFAULT = 0;
export const CHAT_INITIATOR_PROACTIVE = 1;

export const STATUS_SUB_DEFAULT = 0;
export const STATUS_SUB_OWNER_CHANGED = 1;
export const STATUS_SUB_CONTACT_FORM = 2;
export const STATUS_SUB_USER_CLOSED_CHAT = 3;
export const STATUS_SUB_START_ON_KEY_UP = 4;
export const STATUS_SUB_SURVEY_SHOW = 5;
export const STATUS_SUB_SURVEY_COLLECTED = 6;
export const STATUS_SUB_OFFLINE_REQUEST = 7;
export const STATUS_SUB_ON_HOLD = 8;